import React, { useEffect, useState, Fragment } from 'react';
import { connect, useStore } from 'react-redux';
import { useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from '../../../common/commonUtil';
import "../../../resources/css/search/search.css";
import arrow from '../../../resources/icons/arw.svg';
import circle from '../../../resources_membership_hotel/icons/ico_circle.svg';
import cross from '../../../resources/icons/ico_X.svg';
import minus from '../../../resources_membership_hotel/icons/ico_minus.svg';
import slash from '../../../resources_membership_hotel/icons/ico_slash.svg';
import { Image } from "../../atoms/image";
import { ImageButton } from '../../atoms/imageButton';
import { Label } from '../../atoms/label';
import { PrivilegeIcon } from '../../atoms/privilegeIcon';
import './../../../resources_membership_hotel/css/hotel/reserve.css';
import './../../../resources_membership_hotel/css/hotel/crawlSearch.css';
import { WeeksDateCrawl } from '../../molecules/weeksDateCrawl';
import { WeeksDateCrawlFacility } from '../../molecules/weeksDateCrawlFacility';
import Const from '../../../const/Const';
import { Link } from '../../atoms/link';
import messageConst from '../../../const/messageConst';

const VacancyInfoCrawlContainerCallender = (props) => {
    const {
        checkIn,
        checkOut,
        room,
        setRoom,
        resvKaiinken,
        grade,
        roomDetailCriteria,
        membershipFacility,
        setMembershipFacility,
        searchVacancyParam,
        setMembershipSearchParam,
        detailFlg,
        onClickDetail,
        titleFacilityName,
        onClickBackFacilityList,
        onClickOpenFacilityCalendarWindow,
        onClickOpenCrawlWindow,
        onClickOpenRoomDetailPopup,
        onClickOpenRestaurantVacancyPopup,
        setDispFacility,
        setCheckIn,
        setCheckOut,
        firstDate,
        adultNum,
        childNum,
        setAdultNum,
        setChildNum,
        onClickMoveWeeks,
        getCalendarStartDate,
    } = props;

    const isMobilePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [mobilePhone, setMobilePhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const history = useHistory();
    const store = useStore();

    useEffect(() => {
        if (isMobilePhone) {
            setMobilePhone(true);
        } else {
            setMobilePhone(false);
        }
    }, [isMobilePhone]);

    // 数字を押下した場合の処理
    const toList = (facilityId, date, machiFlg, roomType) => {
        // チェックイン
        const checkInDate = new Date(date);
        const startDate = commonUtil.getStringFromDate(checkInDate, "yyyy-MM-dd");

        // チェックアウト
        const checkOutDate = new Date(checkInDate);
        const nightNum = searchVacancyParam.nightsNumber;
        checkOutDate.setDate(checkOutDate.getDate() + Number(nightNum));

        // 大人人数
        let newAdultNum = [...adultNum]
        newAdultNum.forEach((data) => {
            if (data.id == searchVacancyParam.adults) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })

        // 子供人数
        let newChildNum = [...childNum]
        newChildNum.forEach((data) => {
            if (data.id == searchVacancyParam.children) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })
        
        // 部屋数
        let newRoom = [...room]
        newRoom.forEach((data) => {
            if (data.id == searchVacancyParam.roomCnt) {
                data.selected = true;
            } else {
                data.selected = false;
            }
        })

        // 施設
        let facilityArray = [];
        facilityArray.push(facilityId);
        let dispText = "";
        let newMembership = [];
        membershipFacility.membership.forEach(group => {
            group.checked = false;
            group.shisetsuList.forEach(item => {
                if (item.id === facilityId) {
                    dispText = dispText + (dispText == "" ? "" : ", ");
                    dispText = dispText + item.value;
                    item.checked = true;
                } else {
                    item.checked = false;
                }
            })
            newMembership.push(group);
        })
        let newIppan = [];
        membershipFacility.ippan.forEach(group => {
            group.checked = false;
            group.shisetsuList.forEach(item => {
                if (item.id === facilityId) {
                    dispText = dispText + (dispText == "" ? "" : ", ");
                    dispText = dispText + item.value;
                    item.checked = true;
                } else {
                    item.checked = false;
                }
            })
            newIppan.push(group);
        })
        setMembershipFacility({ membership: newMembership, ippan: newIppan });
        setDispFacility(dispText);

        // 検索条件設定
        setMembershipSearchParam({
            checkInDate: startDate,
            checkOutDate: commonUtil.getStringFromDate(checkOutDate, "yyyy-MM-dd"),
            nights: nightNum,
            shisetsuCdList: facilityArray,
            adultCnt: searchVacancyParam.adults,
            childCnt: searchVacancyParam.children,
            roomCnt: searchVacancyParam.roomCnt,
            keiyakuNo: searchVacancyParam.keiyakuNo,
            planConditionsCdList: [],
            roomGradeCdList: searchVacancyParam.roomGradeList,
            foodCdList: [],
            privilegedServiceCdList: [],
            kaiinkenCd: searchVacancyParam.kaiinkenCd,
            kaiinkenNo: searchVacancyParam.kaiinkenNo,
            riyoKaiinkenSyubetCd: searchVacancyParam.riyoKaiinKenSbtKbn,
            crawlMachiFlg: machiFlg,
            roomType: roomType
        });
        if (searchVacancyParam.keiyakuNo != Const.MASTER_CONTRACT_NO) {
            setCheckIn(checkInDate);
            setCheckOut(checkOutDate);
            setAdultNum(newAdultNum);
            setChildNum(newChildNum);
            setRoom(newRoom);
            history.push("/reserve/hotel/searchResult");
        } else {
            onClickOpenCrawlWindow("search");
        }
    }

    const onClickFacility = (facilityId, facilityName) => {

        let startDate;

        // 2週間カレンダーのスタート日
        let startDate2w = getCalendarStartDate();

        startDate = new Date(startDate2w);
        startDate.setMonth(startDate.getMonth() - 1);
        startDate.setDate(25);

        const today = new Date();
        if ((today.getFullYear() === startDate2w.getFullYear() && today.getMonth() === startDate2w.getMonth()) || today >= startDate) {
            startDate = new Date(today);
        }

        // 室数
        let vacancyNum = 1;
        room.forEach(data => {
            if (data.selected === true) vacancyNum = parseInt(data.id);
        });

        // 1室あたりの人数
        let adults = 2;
        adultNum.forEach((data) => {
            if (data.selected === true) adults = parseInt(data.id);
        });
        let children = 0;
        childNum.forEach((data) => {
            if (data.selected === true) children = parseInt(data.id);
        });
        let guestCnt = adults + children;

        // 会員権
        let keiyakuNo = "";
        let kaiinkenCd = "";
        let kaiinkenNo = "";
        let riyoKaiinKenSbtKbn = "";
        resvKaiinken.forEach((data) => {
            if (data.selected === true) {
                keiyakuNo = data.keiyakuNo;
                kaiinkenCd = data.id;
                kaiinkenNo = data.value;
                riyoKaiinKenSbtKbn = data.riyoKaiinkenSyubetCd;
            }
        });

        // グレード
        let gradeArray = [];
        grade.forEach((data) => {
            if (data.checked === true) gradeArray.push(data.id);
        });

        // 部屋詳細条件CD
        let roomConditionArray = [];
        roomDetailCriteria.forEach((data) => {
            if (data.checked === true) roomConditionArray.push(data.id);
        });

        let req = {};
        if (keiyakuNo) {
            req = {
                keiyakuNo: keiyakuNo,
                roomGradeList: gradeArray,
                startDate: startDate,
                shisetsuCd: facilityId,
                shisetsuCdList: [facilityId],
                roomCnt: vacancyNum,
                guestCnt: guestCnt,
                riyoKaiinKenSbtKbn: riyoKaiinKenSbtKbn,
                crawlFlg: true,
                roomConditionCdList: roomConditionArray
            }
        } else {
            req = {
                keiyakuNo: Const.MASTER_CONTRACT_NO,
                roomGradeList: gradeArray,
                startDate: startDate,
                shisetsuCd: facilityId,
                shisetsuCdList: [facilityId],
                roomCnt: vacancyNum,
                guestCnt: guestCnt,
                riyoKaiinKenSbtKbn: "1",
                crawlFlg: true,
                roomConditionCdList: roomConditionArray
            }
        }
        onClickOpenFacilityCalendarWindow(req, facilityName, startDate2w);
    }

    return (
        <div style={{ width: "100%" }}>
            <div style={isMobilePhone ? {
                textAlign: "left", display: "flex", marginTop: "1rem", marginLeft: "10px", flexWrap: "wrap", marginLeft: "calc(5% + 10px)",
                width: "90%"
            } : {
                textAlign: "left", display: "flex", marginTop: "1rem", marginLeft: "10px", flexWrap: "wrap", marginLeft: "10px",
            }}
                id="searchFacilityResult">
                <div style={style.tableImageStyle}>
                    <Image image={circle} style={mobilePhone ? style.imageStyleMobile : style.imageStyle} />
                    <Label label={":空席あり"} style={mobilePhone ? style.usageGuideMobile : style.usageGuide} />
                </div>
                <div style={style.tableImageStyle} >
                    <Label label={"０"} style={mobilePhone ? style.imageStyleMobile : style.imageStyle} />
                    <Label label={":交換・キャンセル待ち"} style={mobilePhone ? style.usageGuideMobile : style.usageGuide} />
                </div>
                <div style={style.tableImageStyle} >
                    <Image image={cross} style={mobilePhone ? style.imageStyleMobile : style.imageStyle} />
                    <Label label={":満室"} style={mobilePhone ? style.usageGuideMobile : style.usageGuide} />
                </div>
                <div style={style.tableImageStyle} >
                    <Image image={minus} style={mobilePhone ? style.imageStyleMobile : style.imageStyle} />
                    <Label label={":クローズ または 該当なし"} style={mobilePhone ? style.usageGuideMobile : style.usageGuide} />
                </div>
                <div style={style.tableImageStyle} >
                    <Image image={slash} style={mobilePhone ? style.imageStyleMobile : style.imageStyle} />
                    <Label label={":予約受付対象外"} style={mobilePhone ? style.usageGuideMobile : style.usageGuide} />
                </div>
                <div style={style.tableImageStyle} >
                    <Label label={"占"} style={mobilePhone ? style.imageStyleMobile : style.imageStyle} />
                    <Label label={":占有日"} style={mobilePhone ? style.usageGuideMobile : style.usageGuide} />
                </div>
            </div>
            <div className={props.vacancyInfo !== undefined && props.vacancyWeek !== undefined && props.vacancyInfo.length !== 0 && props.vacancyWeek.length !== 0 ? 'membership_vacancy_acc_info_2' : "hiddenItem"}>
                各ホテル名をクリックすると1ヶ月分の空室状況が確認できます
            </div>
            {/* PC */}
            <Fragment>
                <div style={{ width: "100%", position: "relative"}}>
                    <div style={{ display: "flex", justifyContent: "space-between", width: "calc(100% - 40px)", margin: "0px auto", }}>
                        <ImageButton btnClass={"arrowBtn"} imgClass={"arrowBack"} onClick={() => onClickMoveWeeks("back", mobilePhone, detailFlg)} image={arrow} />
                        <div>{props.MonthHead}</div>
                        <ImageButton btnClass={"arrowBtn"} imgClass={"arrowNext"} onClick={() => onClickMoveWeeks("next", mobilePhone, detailFlg)} image={arrow} />
                    </div>
                    {isMobilePhone ?
                        detailFlg ?
                            <>
                                <div className="crawlSearch_backFacilityListWrapper">
                                    <Link
                                        linkTitle="＜施設一覧に戻る"
                                        onClick={onClickBackFacilityList}
                                        className="crawlSearch_backFacilityList"
                                    />
                                </div>
                                {props.vacancyInfo !== undefined && props.vacancyWeek !== undefined && props.vacancyInfo.length !== 0 && props.vacancyWeek.length !== 0 ?
                                    <>
                                        <div className={'crawlSearch_roomTable'}>
                                            <WeeksDateCrawlFacility
                                                data={props.vacancyWeek.filter((value, index) => index < 7)}
                                                roomData={props.roomVacancyInfo.map(value => {
                                                    let newObj = { ...value };
                                                    newObj.vacancyDateList = newObj.vacancyDateList.filter((vacancy, index) => index < 7);
                                                    return newObj;
                                                })}
                                                titleFacilityName={titleFacilityName}
                                                onClick={toList}
                                                onClickOpenRoomDetailPopup={onClickOpenRoomDetailPopup}
                                                onClickOpenRestaurantVacancyPopup={onClickOpenRestaurantVacancyPopup}
                                                responsiveFlg={true}
                                            />
                                        </div>
                                        <div className={'crawlSearch_restaurantTable'}>
                                            <WeeksDateCrawlFacility
                                                data={props.vacancyWeek.filter((value, index) => index < 7)}
                                                restaurantData={props.restaurantVacancyInfo.map(value => {
                                                    let newObj = { ...value };
                                                    newObj.vacancyDateList = newObj.vacancyDateList.filter((vacancy, index) => index < 7);
                                                    return newObj;
                                                })}
                                                titleFacilityName={titleFacilityName}
                                                onClick={toList}
                                                onClickOpenRoomDetailPopup={onClickOpenRoomDetailPopup}
                                                onClickOpenRestaurantVacancyPopup={onClickOpenRestaurantVacancyPopup}
                                                responsiveFlg={true}
                                            />
                                        </div>
                                    </>
                                    : null
                                }
                            </>
                            :
                            <div className={props.vacancyInfo.length > 3 ? 'crawlSearch_table2' : 'crawlSearch_table1'}>
                                {props.vacancyInfo !== undefined && props.vacancyWeek !== undefined && props.vacancyInfo.length !== 0 && props.vacancyWeek.length !== 0 ?
                                    <WeeksDateCrawl
                                        data={props.vacancyWeek.filter((value, index) => index < 7)}
                                        data2={props.vacancyInfo.map(value => {
                                            let newObj = { ...value };
                                            newObj.vacancyDateList = newObj.vacancyDateList.filter((vacancy, index) => index < 7);
                                            return newObj;
                                        })}
                                        onClick={toList}
                                        onClickFacility={onClickFacility}
                                        onClickDetail={onClickDetail}
                                        responsiveFlg={true}
                                    />
                                    : null
                                }
                            </div>
                        :
                        detailFlg ?
                            <>
                                <div className="crawlSearch_backFacilityListWrapper">
                                    <Link
                                        linkTitle="＜施設一覧に戻る"
                                        onClick={onClickBackFacilityList}
                                        className="crawlSearch_backFacilityList"
                                    />
                                </div>
                                {props.vacancyInfo !== undefined && props.vacancyWeek !== undefined && props.vacancyInfo.length !== 0 && props.vacancyWeek.length !== 0 ?
                                    <>
                                        <div className={'crawlSearch_roomTable'}>
                                            <WeeksDateCrawlFacility
                                                data={props.vacancyWeek}
                                                roomData={props.roomVacancyInfo}
                                                titleFacilityName={titleFacilityName}
                                                onClick={toList}
                                                onClickOpenRoomDetailPopup={onClickOpenRoomDetailPopup}
                                                onClickOpenRestaurantVacancyPopup={onClickOpenRestaurantVacancyPopup}
                                                responsiveFlg={false}

                                            />
                                        </div>
                                        <div className={'crawlSearch_restaurantTable'}>
                                            <WeeksDateCrawlFacility
                                                data={props.vacancyWeek}
                                                restaurantData={props.restaurantVacancyInfo}
                                                titleFacilityName={titleFacilityName}
                                                onClick={toList}
                                                onClickOpenRoomDetailPopup={onClickOpenRoomDetailPopup}
                                                onClickOpenRestaurantVacancyPopup={onClickOpenRestaurantVacancyPopup}
                                                responsiveFlg={false}
                                            />
                                        </div>
                                    </>
                                    : null
                                }
                            </>
                            :
                            <div className={props.vacancyInfo.length > 4 ? 'crawlSearch_table2' : 'crawlSearch_table1'}>
                                {props.vacancyInfo !== undefined && props.vacancyWeek !== undefined && props.vacancyInfo.length !== 0 && props.vacancyWeek.length !== 0 ?
                                    <WeeksDateCrawl
                                        data={props.vacancyWeek}
                                        data2={props.vacancyInfo}
                                        onClick={toList}
                                        onClickFacility={onClickFacility}
                                        onClickDetail={onClickDetail}
                                        responsiveFlg={false}
                                    />
                                    : null
                                }
                            </div>
                    }
                </div>
                <div className="calendarAttention">
                    <Label label={messageConst.ROOM_PRICE_MESSAGE} className="priceGuide" />
                    <div style={isWideTablet ? { textAlign: "left", display: "block", marginLeft: "10px" } : { textAlign: "left", display: "flex", marginLeft: "10px" }}>
                        <Label label={"※タイムシェアカレンダー　色凡例"} style={style.rightGuide} />
                        <div style={{ display: "flex" }}>
                            <div style={style.tableImageStyle}>
                                <PrivilegeIcon className="gold" />
                                <Label label={":ゴールド"} style={style.colorText} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <PrivilegeIcon className="red" />
                                <Label label={":レッド"} style={style.colorText} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <PrivilegeIcon className="white" />
                                <Label label={":ホワイト"} style={style.colorText} />
                            </div>
                            <div style={style.tableImageStyle} >
                                <PrivilegeIcon className="blue" />
                                <Label label={":ブルー"} style={style.colorText} />
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        </div>
    );
}


const style = {
    container: {
        marginRight: "auto",
        marginLeft: "auto",
    },
    line: {
        clear: "both",
    },
    usageGuide: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0.2rem",
    },
    usageGuideMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0.5rem 0.2rem",
    },
    colorText: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0",
    },
    colorTextMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0.5rem 0",
    },
    rightGuide: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 1rem 0.5rem 0.2rem",
        color: "rgb(173, 173, 173)",
    },
    rightGuideMobile: {
        fontSize: "0.5rem",
        position: "relative",
        display: "inline-block",
        paddingTop: "30px",
        padding: "0.5rem 0.5rem 0rem 0.2rem",
        color: "rgb(173, 173, 173)",
    },
    tablePC1: {
        width: "100%",
        maxHeight: "450px",
    },
    tablePC2: {
        width: "100%",
        overflowX: "hidden",
        overflowY: "scroll",
        maxHeight: "450px",
    },
    tableSP1: {
        width: "100%",
        maxHeight: "250px",
        borderTop: "rgb(184, 183, 183) solid 1px",
    },
    tableSP2: {
        width: "100%",
        borderTop: "rgb(184, 183, 183) solid 1px",
    },
    tableSP3: {
        width: "100%",
        maxHeight: "250px",
    },
    tableSP4: {
        width: "100%",
    },
    tableImageStyle: {
        display: "flex",
        alignItems: "center",
    },

    imageStyle: {
        width: "11px",
        margin: "auto",
    },
    imageStyleMobile: {
        width: "11px",
        margin: "auto",
    },
    callenderScrollMobile: {
        overflow: "hidden scroll",
        maxHeight: "calc(100vh - 190px)",
        borderTop: "rgb(184, 183, 183) solid 1px",
        borderBottom: "rgb(184, 183, 183) solid 1px",
    }
}

const mapStateToProps = (state) => {
    return {
        checkIn: state.checkIn,
        checkOut: state.checkOut,
        room: state.room,
        resvKaiinken: state.resvKaiinken,
        grade: state.grade,
        roomDetailCriteria: state.roomDetailCriteria,
        membershipFacility: state.membershipFacility,
        adultNum: state.adultNum,
        childNum: state.childNum,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setRoom: (item) => {
            dispatch({ type: "ROOM", payload: { room: item } })
        },
        setGrade: (item) => {
            dispatch({ type: "GRADE", payload: { grade: item } })
        },
        setRoomDetailCriteria: (item) => {
            dispatch({ type: "ROOM_DETAIL_CRITERIA", payload: { roomDetailCriteria: item } })
        },
        setMembershipFacility: (item) => {
            dispatch({ type: "MEMBERSHIP_FACILITY", payload: { membershipFacility: item } })
        },
        setMembershipSearchParam: (item) => {
            dispatch({ type: "MEMBERSHIP_SEARCH_PARAM", payload: { membershipSearchParam: item } })
        },
        setDispFacility: (item) => {
            dispatch({ type: "DISP_FACILITY", payload: { dispFacility: item } })
        },
        setCheckIn: (item) => {
            dispatch({ type: "CHECKIN", payload: { checkIn: item } })
        },
        setCheckOut: (item) => {
            dispatch({ type: "CHECKOUT", payload: { checkOut: item } })
        },
        setAdultNum: (item) => {
            dispatch({ type: "ADULT_NUM", payload: { adultNum: item } })
        },
        setChildNum: (item) => {
            dispatch({ type: "CHILD_NUM", payload: { childNum: item } })
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VacancyInfoCrawlContainerCallender);
